<template>
  <div class="document" v-if="documents[currentDocument]">
    <progress-bar></progress-bar>
    <h3 class="document__header">
      <icon name="envelope-open" height="15" width="20"></icon>
      <span>{{ documents[currentDocument].title }}</span>
    </h3>
    <template v-for="(page, pageIndex) in documents[currentDocument].pages">
      <div class="document__page">
        <img :src="page.src" />
        <template v-if="documents[currentDocument].fields[pageIndex + 1]">
          <template v-for="(field, fieldIndex) in documents[currentDocument].fields[pageIndex + 1]">
            <document-field
              :pageIndex="pageIndex + 1"
              :fieldIndex="fieldIndex"
              :field="field"
              :openFieldPopup="openFieldPopup"
              :closeFieldPopup="closeFieldPopup"
              :activePopupId="activePopupId"
              :key="field.id"></document-field>
          </template>
        </template>
      </div>
    </template>
    <document-navigation v-if="documents.length > 1"></document-navigation>
  </div>
</template>

<script>
  import ProgressBar from '@/components/ProgressBar';
  import DocumentField from '@/components/DocumentField';
  import DocumentNavigation from '@/components/DocumentNavigation';

  export default {
    name: 'document',
    components: {
      ProgressBar,
      DocumentField,
      DocumentNavigation,
    },
    data() {
      return {
        documents: this.$store.state.envelope.documents,
        currentDocument: this.$store.state.currentDocument,
        activePopupId: this.$store.state.activePopupId,
        showOverlay: false,
      };
    },
    created() {
      this.$bus.$on('nextField', ({ inputId }) => {
        this.activePopupId = inputId;
      });
      this.$bus.$on('closeFieldPopup', () => {
        this.activePopupId = 0;
      });
      this.$bus.$on('nextDocument', () => {
        this.currentDocument = this.$store.state.currentDocument;
      });
      this.$bus.$on('closedFieldPopup', () => {
        this.showOverlay = false;
      });
      this.$bus.$on('fieldConfirmed', () => {
        this.goToNextField();
      });
      window.addEventListener('keyup', this.handleTab);
    },
    methods: {
      openFieldPopup(event) {
        const fieldId = event.target.getAttribute('data-id');
        const field = this.$store.getters.getField(fieldId, false);
        const currentPartyId = this.$store.getters.currentPartyId;
        const viewportmeta = document.querySelector('meta[name=viewport]');
        viewportmeta.setAttribute('content', 'width=device-width, initial-scale=1');
        if (field.party_id === currentPartyId && !(field.merge_field && field.content)) {
          this.activePopupId = parseInt(fieldId, 10);
          this.$store.commit('setActiveStates', {
            currentPage: event.target.getAttribute('data-page'),
            currentField: event.target.getAttribute('data-input'),
            activePopupId: this.activePopupId,
          });
          this.$bus.$emit('openedFieldPopup');
          this.$bus.$emit('scrollingDown');
        }
      },
      closeFieldPopup() {
        this.activePopupId = 0;
        this.$bus.$emit('closedFieldPopup');
      },
      handleTab(event) {
        if (event.code === 'Tab') {
          event.preventDefault();
          if (this.$store.state.isPopupActive) {
            this.$bus.$emit('confirmField');
          } else {
            this.goToNextField();
          }
        }
      },
      goToNextField() {
        const isEnvelopeDone = this.$store.getters.isEnvelopeComplete();
        const isDocumentDone = this.$store.getters.isDocumentDone();
        const nextField = this.$store.getters.nextField();
        if (!isEnvelopeDone) {
          if (isDocumentDone) {
            this.$store.dispatch('nextDocument');
            this.$bus.$emit('nextDocument');
          } else {
            this.$store.commit('setActiveStates', {
              currentPage: nextField.page,
              currentField: nextField.index,
              activePopupId: nextField.id,
            });
            this.activePopupId = nextField.id;
            this.$bus.$emit('scrollBody');
            if (nextField.type !== 'checkbox') {
              this.$bus.$emit('openedFieldPopup');
            }
            if (nextField.type === 'checkbox') {
              this.$bus.$emit('highlightField', { field: nextField });
            }
          }
        }
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass'
  $color-page-shadow: $color-grey
  .document
    float: right
    width: 75%
    padding: $spacing-large $spacing-large 87px
    position: relative
    &__header
      width: 95%
      margin: 0 auto
      background-color: $signable-secondary-3
      padding: $spacing-base
      margin-bottom: -$spacing-base
      color: #fff
      span
        word-break: break-all
        line-height: 1.5
    &__page
      position: relative
      width: 95%
      margin: $spacing-base auto
      box-shadow: 0 5px 20px -5px $color-page-shadow
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .document
      width: 100%
      padding-top: 42px
  @media screen and (max-width: $screen-size-medium)
    .document
      padding: $spacing-large 0 87px
  @media screen and (max-width: $screen-size-small)
    .document
      padding: 47px 0 87px
</style>



// WEBPACK FOOTER //
// Document.vue?6cf11e8e